import { ColorEnum } from '@/constants/color'
import { State } from '@/features/orders/constants/app'
import { DeliveryTime } from '@/features/orders/types/app'
import Typography from '@/features/ui/typography'
import { formatHumanReadableDurationFromMinutes } from '@/utils/format-duration'
import dayjs from 'dayjs'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface OrderCompletionIndicatorProps {
    state: State
    acceptedDeliveryTime?: DeliveryTime
    deliveredAt?: string
}

const OrderCompletionIndicator: FC<OrderCompletionIndicatorProps> = ({
    state,
    acceptedDeliveryTime,
    deliveredAt,
}) => {
    const { t } = useTranslation()

    if (state === State.Cancelled) {
        return (
            <Typography.Description font="bold" style={{ color: ColorEnum.BRICK_500 }}>
                {t(`order.state.${State.Cancelled}`)}
            </Typography.Description>
        )
    }

    // Settled table accounts are completed without a scheduled delivery time.
    if (!acceptedDeliveryTime || !deliveredAt) {
        return deliveredAt ? (
            <Typography.Description font="bold">
                {dayjs(deliveredAt).format('HH:mm')}
            </Typography.Description>
        ) : null
    }

    const minutesRemainingDuration = dayjs(acceptedDeliveryTime.end).diff(deliveredAt, 'minutes')
    const remainingDuration = `${
        minutesRemainingDuration > 0 ? '+' : ''
    }${formatHumanReadableDurationFromMinutes(minutesRemainingDuration)}`

    const color = minutesRemainingDuration > 0 ? ColorEnum.EMERALD_700 : ColorEnum.BRICK_500

    return (
        <Typography.Description font="bold" style={{ color }}>
            {remainingDuration}
        </Typography.Description>
    )
}

export default OrderCompletionIndicator
